import AuthPersistence from "./../AuthPersistence";

export default {

    AUTHENTICATE_USER(state, auth) {
        state.isUserAuthenticated = true;
        this.UPDATE_USER(state, auth.user);
        this.UPDATE_TOKEN(state, auth.token);
    },

    UPDATE_USER(state, user) {
        state.auth.user = {
            uuid: user.uuid,
            ...user.attributes,
        };
        if (state.auth.hasOwnProperty('token')) {
            state.isUserAuthenticated = true;
        }
    },

    UPDATE_TOKEN(state, token) {
        state.auth.token = token;
        state.lastAuthTimestamp = null;
        state.isUserAuthenticated = true;
    },

    IS_REFRESHING_TOKEN(state, status) {
        status = typeof status === "boolean" ? status : true;
        state.isRefreshingToken = status;
    },

    LOGOUT(state) {
        state.isUserAuthenticated = false;
        state.lastAuthTimestamp = null;
        state.isRefreshingToken = false;
        state.auth = {
            user: null,
            token: null,
        };
        AuthPersistence.removeAuthCookies();
    },

    UPDATE_LAST_AUTH_TIMESTAMP(state) {
        state.lastAuthTimestamp = Date.now();
    },
    UPDATE_USER_LOADED(state) {
        state.userLoaded = true;
    },
    UPDATE_USER_ATTRIBUTE(state, {attribute, value}) {
        state.auth.user[attribute] = value;
    },
    UPDATE_LOGOUT_LOADING(state, value) {
        state.logoutLoading = value;
    }
};
